// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__o6GAF","a":"Footer_a__8Z8fY"};